import {InjectionToken} from "@angular/core";
import {ICreateAppModalService} from "./i-create-app-modal.service";

export const createAppModalServiceInjectionToken: InjectionToken<ICreateAppModalService> = new InjectionToken("digital-signage.developer-dashboard.dashboard-web.CreateAppModalService");
